import { createApiCaller, SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useEventApi() {
  const callApi = useApiCall();

  return {
    callGetGameDetails: createApiCaller(callApi, SAGA_ACTIONS.GAME_DETAILS),
    callGetGroups: createApiCaller(callApi, SAGA_ACTIONS.EVENT.GROUPS),
    callGetRodeoEvents: createApiCaller(callApi, SAGA_ACTIONS.EVENT.RODEO_EVENTS),
    callGetPastRodeoEvents: createApiCaller(callApi, SAGA_ACTIONS.EVENT.PAST_RODEO_EVENTS),
    callGetUpcomingEvents: createApiCaller(callApi, SAGA_ACTIONS.EVENT.UPCOMING_EVENTS),
    callGetPerformances: createApiCaller(callApi, SAGA_ACTIONS.EVENT.PERFORMANCES),
    callGetEvents: createApiCaller(callApi, SAGA_ACTIONS.EVENT.EVENTS),
    callGetRiders: createApiCaller(callApi, SAGA_ACTIONS.EVENT.RIDERS),
    callPickRider: createApiCaller(callApi, SAGA_ACTIONS.EVENT.PICK_RIDER),
    callGetGameStatusText: createApiCaller(callApi, SAGA_ACTIONS.EVENT.GAME_STATUS_TEXT),
    callGetRodeoEventGeoLocations: createApiCaller(callApi, SAGA_ACTIONS.EVENT.GET_RODEO_EVENT_GEO_LOCATIONS),
    callGetYourPicks: createApiCaller(callApi, SAGA_ACTIONS.EVENT.YOUR_PICKS),
    callGetMyTeam: createApiCaller(callApi, SAGA_ACTIONS.EVENT.MY_TEAM),
    callWinningTicketResults: createApiCaller(callApi, SAGA_ACTIONS.EVENT.MY_CORRECT_PICKS),
    callApplyLeagueCode: createApiCaller(callApi, SAGA_ACTIONS.EVENT.APPLY_LEAGUE_CODE),
    callGetShareImageLink: createApiCaller(callApi, SAGA_ACTIONS.EVENT.GET_SHARE_IMAGE_LINK),
    callMostPopularPicks: createApiCaller(callApi, SAGA_ACTIONS.EVENT.MOST_POPULAR_PICKS),
    callGetLeagueLeaderboard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.LEAGUE_LEADERBOARD),
    callGetVsLeagueLeaderboard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.VS_LEAGUE_LEADERBOARD),
    callViewGroupLeaderBoard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.GROUP_LEADER_BOARD),
    callViewLeaderBoard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.LEADERBOARD),
    callTvImage: createApiCaller(callApi, SAGA_ACTIONS.EVENT.TV_IMAGE),
    callGetActivePerformances: createApiCaller(callApi, SAGA_ACTIONS.EVENT.ACTIVE_PERFORMANCES),
    callGetCategorizedPerformances: createApiCaller(callApi, SAGA_ACTIONS.EVENT.CATEGORIZED_PERFORMANCES),
    callGetCategorizedRodeoEvents: createApiCaller(callApi, SAGA_ACTIONS.EVENT.CATEGORIZED_RODEO_EVENTS),
    callGetCategorizedEventGroups: createApiCaller(callApi, SAGA_ACTIONS.EVENT.CATEGORIZED_EVENT_GROUPS),
    callGetEventGroupsLeaderboard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.EVENT_GROUPS_LEADERBOARD),
    callGetRodeoLeaderboard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.RODEO_LEADERBOARD),
    callGetPerformanceLeaderboard: createApiCaller(callApi, SAGA_ACTIONS.EVENT.PERFORMANCE_LEADERBOARD),
    callGetRodeoEventEvents: createApiCaller(callApi, SAGA_ACTIONS.EVENT.RODEO_EVENT_EVENTS),
    callRodeoEventUserPick: createApiCaller(callApi, SAGA_ACTIONS.EVENT.RODEO_EVENT_USER_PICK),
    callGetRodeoEventYourPicks: createApiCaller(callApi, SAGA_ACTIONS.EVENT.RODEO_EVENT_YOUR_PICKS),
  };
}
